interface ErrorAlertProps {
  error: string | null;
  onClose?: () => void;
  className?: string;
}

export function ErrorAlert({ error, onClose, className = '' }: ErrorAlertProps) {
  if (!error) return null;

  return (
    <div className={`bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg mb-4 flex items-start gap-3 ${className}`}>
      <i className="ri-error-warning-line mt-0.5 shrink-0 text-lg" />
      <div className="flex-1">
        <p className="text-sm">{error}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="text-red-500 hover:text-red-700 shrink-0"
        >
          <i className="ri-close-line" />
        </button>
      )}
    </div>
  );
}
